import { VIOLATION_TYPE_LABELS, VIOLATION_TYPES_ORDERED } from '../api/types'
import type { ViolationType } from '../api/types'

interface Props {
  value: ViolationType[]
  onChange: (v: ViolationType[]) => void
  disabled?: boolean
}

export function ViolationTypePicker({ value, onChange, disabled }: Props) {
  function toggle(type: ViolationType) {
    if (disabled) return
    if (value.includes(type)) {
      onChange(value.filter((v) => v !== type))
    } else {
      onChange([...value, type])
    }
  }

  return (
    <div className="grid grid-cols-2 gap-x-6 gap-y-2">
      {VIOLATION_TYPES_ORDERED.map((type) => {
        const checked = value.includes(type)
        return (
          <label
            key={type}
            className={`flex items-center gap-2 cursor-pointer ${disabled ? 'opacity-50 cursor-not-allowed' : ''}`}
          >
            <input
              type="checkbox"
              checked={checked}
              onChange={() => toggle(type)}
              disabled={disabled}
              className="h-4 w-4 rounded border-border-default accent-[var(--color-brand)]"
            />
            <span className="text-sm text-primary">{VIOLATION_TYPE_LABELS[type]}</span>
          </label>
        )
      })}
    </div>
  )
}
